module.exports = __webpack_public_path__ + "img/banner_batchTOB.ccac76fb.png";